import React, { createContext, useContext, useState, useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchUserFolderMetadata } from "../components/user/file_management/services/fetchUserFolderMetadata";

const FolderContext = createContext();

export function FolderProvider({ children }) {
  const queryClient = useQueryClient();

  // Fetch folders using React Query
  const {
    data: folders = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ["userFolderMetadata"],
    queryFn: fetchUserFolderMetadata,
  });

  // Selected folder state
  const [selectedFolder, setSelectedFolder] = useState(null);

  // Initialize selectedFolder from localStorage or default to first folder or newly created folder
  useEffect(() => {
    if (folders.length === 0) return;

    const savedFolderId = localStorage.getItem("selectedFolderId");
    const folderToSelect =
      folders.find((f) => f.folderId === savedFolderId) || folders[0];
    console.log("Inside the useEffect -> folder id is", selectedFolder);
    setSelectedFolder(folderToSelect);
  }, [folders]);

  // Removed the second useEffect to avoid conflicting updates

  // Update localStorage and invalidate dependent queries on folder change
  const updateSelectedFolder = (folder) => {
    setSelectedFolder(folder);
    if (folder && folder.folderId) {
      localStorage.setItem("selectedFolderId", folder.folderId);
    } else {
      localStorage.removeItem("selectedFolderId");
    }
    // Invalidate queries that depend on selected folder
    queryClient.invalidateQueries({
      queryKey: ["accreditationData", folder?.folderId],
    });
    queryClient.invalidateQueries({ queryKey: ["files", folder?.folderId] });
    // Add other dependent queries as needed
  };

  return (
    <FolderContext.Provider
      value={{
        folders,
        selectedFolder,
        setSelectedFolder: updateSelectedFolder,
        isLoading,
        error,
      }}
    >
      {children}
    </FolderContext.Provider>
  );
}

export function useFolder() {
  const context = useContext(FolderContext);
  if (!context) {
    throw new Error("useFolder must be used within a FolderProvider");
  }
  return context;
}
